import axios from "axios";
import {Message} from "element-ui";
import Router from "@/router";

const origin = location.hostname; //当前访问域名
let requestBase: any = "";
if (process.env.NODE_ENV === "development") {
    requestBase = process.env.VUE_APP_BASE_CRM_API_PROXY;
} else {
    if (origin.indexOf("-testserver") > -1) {
        requestBase = process.env.VUE_APP_DEV_API;
    } else {
        requestBase = process.env.VUE_APP_MASTER_API;
    }
}

const config = {
    baseURL: requestBase,
    timeout: 60 * 1000 * 2, // Timeout
    withCredentials: true, // Check cross-site Access-Control
    // headers: {
    //     "Content-Type": "multipart/form-data"
    // }
};

const _axios1 = axios.create(config);
_axios1.interceptors.request.use(
    (cfg) => {
        return cfg;
    },
    (err) => {
        return Promise.reject(err);
    }
);
_axios1.interceptors.response.use(
    (cfg) => {
        const {error} = cfg.data;
        if (error.returnCode !== 0) {
            if (error.returnCode === 1) {
                window.sessionStorage.clear();
                //   跳转登录页
                Router.push("/login");
                // if (process.env.NODE_ENV === "development") {
                // window.location.href =
                //   "http://192.168.21.185:8080/login?form=" + window.location.origin;


                // } else {
                //   if (origin.indexOf("-testserver") > -1) {
                // window.location.href =
                //   "https://center-testserver.gecacademy.cn/login?form=" +
                //   window.location.origin;
                // } else {
                // window.location.href =
                //   "https://center.gecacademy.cn/login?form=" +
                //   window.location.origin;
                // }
                // }
            }
            if (error.returnMessage !== "请重新登录") {
                Message.error(error.returnMessage);
                return Promise.reject(new Error(error.returnMessage || "Error"));
            }
        } else {
            return cfg.data.data;
        }
    },
    (err) => {
        if (err.message == "timeout of 30000ms exceeded") {
            Message({
                message: "请求超时请重试",
                type: "error",
                duration: 5 * 1000,
            });
        } else {
            Message({
                message: err.message,
                type: "error",
                duration: 5 * 1000,
            });
        }
        return Promise.reject(err);
    }
)
;

export default _axios1;
